import "./FinanceBanner.scss";

const FinanceBanner = () => {

    return (
        <>
            <div className="financeBannerOuterDiv">
                <div className="financeBannerInnerDiv">
                    <div className="financeBannerTextDiv">
                        <button id="financeBannerButton">
                            Innovation and Creativity
                        </button>

                        <p id="financeBannerHeading">
                            Business
                            <span className="financeBannerConsultant"> Consultant </span>
                            & Growth Solution
                        </p>

                        <p id="financeBannerPara">
                            Consultez Is The Place Where Early Adopters And Innovation Enthutiasts Discover Vibrant, Imaginative Technology Before It Reaches
                        </p>

                        <div className="financeBannerButtons">
                            <button id="financeBannerGetStartedBtn">
                                Get Started
                                <span class="material-symbols-outlined">
                                    arrow_forward_ios
                                </span>
                            </button>
                            <button id="financeBannerArrowBtn">
                                <span class="material-symbols-outlined">
                                    play_arrow
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="financeBannerImageDiv">
                        <img src="../assets/img/finance/bannerManImage.png" alt="Man" id="financeBannerManImage" />
                        <img src="../assets/img/finance/bannerRevenueCard.png" alt="Revenue" className="overlay" id="financeBannerRevenueImage" />
                        <img src="../assets/img/finance/bannerInvoiceCard.png" alt="Invoice" className="overlay" id="financeBannerInvoiceImage" />
                        <img src="../assets/img/finance/bannerReportCard.png" alt="Report" className="overlay"
                        id="financeBannerReportImage" />
                    </div>
                </div>
            </div>
        </>
    );
}

export default FinanceBanner;